import { FC, PropsWithChildren } from "react";
import { Controller } from "react-hook-form";
import { ControllerProps } from "react-hook-form";
import { TimePicker, TimePickerProps } from "@mui/x-date-pickers";

interface ReactHookFormTimePickerProps extends TimePickerProps<any> {
  label?: string;
  id?: string;
  controller: Omit<ControllerProps<any>, "render">;
}

const ReactHookFormTimePicker: FC<
  PropsWithChildren<ReactHookFormTimePickerProps>
> = ({ label, controller, children, id, ...props }) => {
  return (
    <Controller
      render={({ field: { onChange, ref, value } }) => (
        <TimePicker
          {...props}
          value={value}
          label={label}
          inputRef={ref}
          slotProps={{
            textField: { size: "small", id, ...props.slotProps?.textField },
          }}
          onChange={onChange}
        />
      )}
      {...controller}
    />
  );
};

export default ReactHookFormTimePicker;
